/*
 * This variable is automatically overwritten during builds and releases.
 * It doesn't need to be updated manually.
 */

/**
 * CCS Frontend release version
 *
 * {@link https://github.com/Crown-Commercial-Service/ccs-frontend-project/releases}
 */
export const version = 'development'
